import React from 'react';
import { TextCard } from '@ajat/design-system/Configurator';
import { ComponentPage, DemoCard, DemoRow, Demo } from '../../shared';
import { PATCH_TEXT } from './patchDemoData';

export const meta = {
  component: TextCard,
  title: 'Text Card',
  group: 'Configurator',
  importPath: '@ajat/design-system/Configurator',
  figmaNode: '4287:23974',
  description:
    'Horizontal option card: 80px thumbnail, uppercase title, optional description and price, and one corner action — Edit (SquarePen, Tertiary/Text) once the option is configured, Add (Plus, Tertiary/Gray) before. Fluid width, min 200px.',
  props: [
    ['image', 'string', '—', 'Thumbnail — contained on a white 80px tile'],
    ['imageAlt', 'string', "''", 'Alt text for the thumbnail'],
    ['title', 'string', '—', 'Option title (typo-h5, uppercase)'],
    ['description', 'node | node[]', '—', 'Muted description; an array renders its parts separated by a gray bullet'],
    ['price', 'string', '—', 'Formatted price, e.g. "112 kr" — rendered through the DS Price'],
    ['originalPrice', 'string', '—', 'Pre-discount price — shows the price as discounted (green + struck original)'],
    ['onClick', 'func', '—', 'Card click — makes the whole card interactive (hover + focus ring)'],
    ['onEdit', 'func', '—', 'Shows the Edit button (wins over onAdd)'],
    ['onAdd', 'func', '—', 'Shows the Add button when there is no onEdit'],
    ['onZoom', 'func', '—', 'Turns the thumbnail zoom icon into its own button'],
    ['editLabel', 'string', "'Edit'", 'Accessible name of the Edit button'],
    ['addLabel', 'string', "'Add'", 'Accessible name of the Add button'],
    ['zoomLabel', 'string', "'Zoom'", 'Accessible name of the zoom button'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Text option',
      code: `import { TextCard } from '@ajat/design-system/Configurator';

<TextCard
  image={textPreview}
  title="Text"
  description={['3 patchar', '3 cm, 5 cm, 9cm']}
  price="112 kr"
  onClick={openTextEditor}
  {...(textConfigured ? { onEdit: openTextEditor } : { onAdd: openTextEditor })}
/>`,
    },
  ],
};

export default function TextCardPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="States" hint="hover the card">
        <DemoRow>
          <Demo caption="EDIT">
            <div className="w-[273px]"><TextCard image={PATCH_TEXT} imageAlt="Text patch" title="Text" price="112 kr" onClick={() => {}} onEdit={() => {}} /></div>
          </Demo>
          <Demo caption="ADD">
            <div className="w-[273px]"><TextCard image={PATCH_TEXT} imageAlt="Text patch" title="Text" price="112 kr" onClick={() => {}} onAdd={() => {}} /></div>
          </Demo>
        </DemoRow>
      </DemoCard>

      <DemoCard title="Description" hint="array parts are joined with a bullet">
        <DemoRow>
          <Demo caption="WITH DESCRIPTION">
            <div className="w-[273px]">
              <TextCard
                image={PATCH_TEXT}
                imageAlt="Text patch"
                title="Text"
                description={['3 patchar', '3 cm, 5 cm, 9cm']}
                price="112 kr"
                onClick={() => {}}
                onEdit={() => {}}
              />
            </div>
          </Demo>
          <Demo caption="TITLE ONLY, NO ACTION">
            <div className="w-[273px]"><TextCard image={PATCH_TEXT} imageAlt="Text patch" title="Text" /></div>
          </Demo>
        </DemoRow>
      </DemoCard>

      <DemoCard title="Discounted" hint="bundle card — OVER/LL Paket step">
        <DemoRow>
          <Demo caption="ADD + DISCOUNT">
            <div className="w-[346px]">
              <TextCard
                image={PATCH_TEXT}
                imageAlt="Bundle"
                title="Pink Vibes"
                description={['3 patchar', '3 cm, 5 cm, 9cm']}
                price="120 kr"
                originalPrice="159 kr"
                onClick={() => {}}
                onAdd={() => {}}
              />
            </div>
          </Demo>
        </DemoRow>
      </DemoCard>
    </ComponentPage>
  );
}
